import { initDB, getSetting, setSetting } from '../db/indexeddb.js';
import { DEFAULT_THEME_ID, THEME_PRESETS } from './themes.js';

const THEME_PRESET_KEY = 'ytcs:theme:preset';
const THEME_ACCENT_KEY = 'ytcs:theme:accent';

// Mirrors for fast startup (avoid flash before IndexedDB is ready)
const LS_PRESET = 'ytcs:theme:preset';
const LS_ACCENT = 'ytcs:theme:accent';

export function getThemeSnapshotSync() {
  const presetId = localStorage.getItem(LS_PRESET) || DEFAULT_THEME_ID;
  const accent = localStorage.getItem(LS_ACCENT) || null;
  return { presetId, accent };
}

export async function loadThemeSettings() {
  const db = await initDB();
  const preset = await getSetting(db, THEME_PRESET_KEY);
  const accent = await getSetting(db, THEME_ACCENT_KEY);
  const presetId = preset?.value || DEFAULT_THEME_ID;
  const accentValue = accent?.value || null;

  // keep localStorage mirrors in sync
  localStorage.setItem(LS_PRESET, presetId);
  if (accentValue) localStorage.setItem(LS_ACCENT, accentValue);
  else localStorage.removeItem(LS_ACCENT);

  return { presetId, accent: accentValue };
}

export async function saveThemePreset(presetId) {
  const db = await initDB();
  const safePresetId = THEME_PRESETS[presetId] ? presetId : DEFAULT_THEME_ID;
  await setSetting(db, THEME_PRESET_KEY, safePresetId);
  localStorage.setItem(LS_PRESET, safePresetId);
  return safePresetId;
}

export async function saveThemeAccent(accentHexOrNull) {
  const db = await initDB();
  const value = accentHexOrNull && String(accentHexOrNull).trim() ? String(accentHexOrNull).trim() : null;
  await setSetting(db, THEME_ACCENT_KEY, value);
  if (value) localStorage.setItem(LS_ACCENT, value);
  else localStorage.removeItem(LS_ACCENT);
  return value;
}
